<template>
  <div class="list-view-main-container">
    <div v-if="!!this.model.Caption && this.model.Group" class="list-view-header-container">
      <v-icon class="list-view-header-icon">mdi-apps</v-icon>
      {{ evaluateExpression(this.model.Caption) }}
    </div>
    <div v-if="routItems.length > 1" class="list-view-toolbar">
      <v-icon class="back" color="#737373" @click="closeFolder()">mdi-arrow-left</v-icon>
      <div class="routItem" v-for="(item, index) in routItems" :key="index">
        {{ item.name }}
        <v-icon class="routIcon" color="var(--accentColor)">mdi-chevron-right</v-icon>
      </div>
    </div>
    <vuescroll :ops="ops">
      <div v-if="listViewItems" class="list-view-container lvc-main">
        <div v-for="(item, index) in listViewItems" :key="index">
          <div class="list-view-item-normal list-view-item" v-if="visible(item)"
            :style="`top:${setRow(item)}; left:${setColumn(item)}; position:${getPosition()}`"
            @click="changedCode(item)"
            @contextmenu="openContextMenu(item, $event)"
          >
            <div class="list-view-icon-container">
              <svg v-if="item" :width="iconSize" :height="iconSize">
                <use :xlink:href="require('../../assets/rmd-icons.svg') + `#ICON_${(item.image || defaultSvg).toUpperCase()}`"></use>
              </svg>
            </div>
            <div class="list-view-caption">
              {{item.name}}
            </div>
          </div>
        </div>
        <context-menu v-model="showContextMenu" :x="x" :y="y" :isAppInIFrame="isAppInIFrame" :isDrListViewNormal="isDrListViewNormal" :itemHaveInFavorite="true" :favoriteTable="!this.model.Group" @openInNewTab="openInNewTab" @toShare="toShare" @removeFromFavorite="remove" @openRenameDialog="openRenameDialog" @menuSettingsAccess="menuSettingsAccess"></context-menu>
        <share-dialog v-model="showShareDialog" :pathText="fullPathText" :pathUrl="fullPathUrl" @closeDialog="closeDialog"></share-dialog>
        <rename-dialog v-model="showRenameDialog" @closeDialog="closeDialog" :caption="caption" @renameFunctionMenu="renameFunctionMenu"></rename-dialog>
      </div>
    </vuescroll>
  </div>
</template>

<script>
import contextMenuMixin from '../../mixins/contextMainMenu-mixin.js'
import baseMixin from '../../mixins/base-mixin'
import inputMixin from '../../mixins/input-mixin'

export default {
  mixins: [contextMenuMixin, baseMixin, inputMixin],
  props: ['isAppInIFrame'],
  components: {
    'context-menu': () => import('./dialogs/contextMenu.vue'),
    'share-dialog': () => import('./dialogs/shareDialog.vue'),
    'rename-dialog': () => import('./dialogs/renameDialog.vue'),
    'vuescroll': () => import('vuescroll')
  },
  data: () => ({
    baseUrl: '',
    listView: undefined,
    selectMenuItem: undefined,
    userSettings: {
      mainColor: '',
      accentColor: '',
      sizeSettingsString: ''
    },
    layoutDescription: undefined,
    defaultSvg: 'IT',
    iconSize: 36,
    iconColor: 'black',
    isDrListViewNormal: true,
    listViewItems: [],
    needShowContextMenu: false,
    needShowShareDialog: false,
    needShowRenameDialog: false,
    loaded: false,
    ops: {
      bar: {
        background: '#aaa',
        size: '10px'
      },
      rail: {
        size: '10px'
      }
    },
    currentParentNpp: '0',
    routItems: [{
      name: '',
      npp: '0'
    }]
  }),
  created() {
    this.routItems[0].name = this.$t('vuetifyWidgets.dr-list-view.desktop')
    this.$store.dispatch('loadMenuListItems', this.model.Group).then(() => {
      this.listViewItems = this.$store.getters.getListViewItems
    })
    this.refreshItems()
  },
  computed: {
    showContextMenu: {
      get() {
        return this.needShowContextMenu
      },
      set(val) {
        this.needShowContextMenu = val
      }
    },
    showShareDialog: {
      get() {
        return this.needShowShareDialog
      },
      set(val) {
        this.needShowShareDialog = val
      }
    },
    showRenameDialog: {
      get() {
        return this.needShowRenameDialog
      },
      set(val) {
        this.needShowRenameDialog = val
      }
    }
  },
  methods: {
    setRow(item) {
      if (item.position) {
        return (94 * item.position.normal.row) + 'px'
      }
    },
    setColumn(item) {
      if (item.position) {
        return (119 * item.position.normal.column) + 'px'
      }
    },
    changedCode(item) {
      if (item.isFolder) {
        this.openFolder(item)
        return
      }
      let menuObject = {codeMenu: item.codeMenu,
        shareParams: item.shareParams,
        ...(item.httpLink && { httpLink: item.httpLink }) // если в item есть httpLink
      }
      // если у функции есть ссылка
      if (menuObject.httpLink) {
        window.open(menuObject.httpLink)
        return
      }
      this.selectMenuItem = menuObject
      if (window.parent && window.parent.postMessage && window.parent != window) {
        window.parent.postMessage({ type: 'CallMainMenuFunction', codeMenu: menuObject.codeMenu }, '*')
        return
      }
      localStorage.setItem('startFromLauncher', true)
      let data = JSON.parse(localStorage.getItem('appMainMenuCacheMenu'))
      let projectCode = data.data.iTEnterpriseMenuQuery.menu.currentProject
      if (projectCode) {
        let parts = projectCode.split('_')
        if (parts.length > 1 && parts[parts.length - 1].length == 2) {
          parts[parts.length - 1] = localStorage.getItem('language')
        }
        projectCode = parts.join('_')
      }
      
      let link = `${this.$store.getters.getBaseUrl}/?${menuObject.shareParams}&startFromLauncher=true${this.parseQueryString(projectCode)}`
      if (this.$store.getters.appModel.ProjectSecurity.OidcEnabled) {
        window.open(link, '_self')
      } else {
        this.$store.dispatch('getRestartTicket').then(() => {
          let ticket = ''
          if (this.$store.getters.getRestartTicket) {
            ticket = `&ticket=${this.$store.getters.getRestartTicket}`
          }
          window.open(`${link}${ticket}`, '_self')
        })
      }
    },
    visible(item) {
      return item && ((this.currentParentNpp == item.parentNpp && item.position) || this.model.Group)
    },
    getPosition() {
      return this.model.Group ? 'unset' : 'absolute'
    },
    parseQueryString(projectCode) {
      let query = location.search
      if (query.indexOf('?') >= 0) {
        query = query.substring(query.indexOf('?') + 1)
      }
      let parts = query.split('&')
      if (parts.length == 1 && !parts[0]) {
        parts = []
      }
      let params = {}

      if (projectCode) {
        params.proj = projectCode
      }

      for (var i = 0, ii = parts.length; i < ii; ++i) {
        let param = parts[i].split('=')
        let key = param[0].toLowerCase()
        let value = param.length > 1 ? param[1] : null
        params[decodeURIComponent(key)] = decodeURIComponent(value)
      }
      let noNeededParams = ['changeuser', 'restart', 'ticket', 'clientdevice', 'islandscape']
      let startParams = []
      for (var param in params) {
        if (noNeededParams.includes(param)) {
          continue
        }
        if (param == 'par3') {
          var oldValue = params[param].substring(1)	
          oldValue = oldValue.split('/')
          var newValue = []
          for (var value in oldValue) {
            if (oldValue[value].startsWith('ITCALL') || oldValue[value].startsWith('KEYMNU')) {
              continue
            }
            newValue.push(oldValue[value])
          }
          params[param] = (`;/${newValue.join('/')}`)
        }
        startParams.push(`${param}=${params[param]}`)
      }
      return startParams.length > 0 ? `&${startParams.join('&')}` : ''
    },
    refreshItems() {
      if (!this.model.Group) {
        let data = JSON.parse(localStorage.getItem('appMainMenuCacheMenu'))
        this.listViewItems = data.data.iTEnterpriseMenuQuery.listView.items
        setTimeout(() => { this.refreshItems() }, 2000)
      }
    },
    remove() {
      this.removeFromFavorite()
      let data = JSON.parse(localStorage.getItem('appMainMenuCacheMenu'))
      data.data.iTEnterpriseMenuQuery.listView.items = this.listViewItems.filter(x => x.codeMenu !== this.selectItem.codeMenu)
      localStorage.setItem('appMainMenuCacheMenu', JSON.stringify(data))
    },
    openFolder(item) {
      this.routItems.push(item)
      this.currentParentNpp = item.npp
    },
    closeFolder() {
      this.routItems.pop()
      this.currentParentNpp = this.routItems[this.routItems.length - 1].npp
    }
  }
}
</script>

<style>
.list-view-header-container {
  display: flex;
  align-items: center;
  padding: 16px 14px 0px 0px;
  font-weight: normal;
  font-size: 14px;
  line-height: 16px;
  color: #212121;
}
.list-view-header-icon {
  margin: 0px 14px;
}

.list-view-header-icon.v-icon {
  font-size: 16px;
}

.list-view-icon-container {
  fill: rgb(var(--md-pallete-rgb-600))
}

.list-view-toolbar {
  display: flex;
  align-items: center;
}

.list-view-toolbar .back {
  padding: 5px;
  border-radius: 50%;
  cursor: pointer;
  margin-right: 5px;
}

.list-view-toolbar .back.v-icon.v-icon:after {
  display: none;
}

.list-view-toolbar .back:hover {
  background: #eaeaea;
}

.list-view-toolbar .routItem {
  color: var(--accentColor);
  font-size: 16px;
}

.list-view-toolbar .routItem .routIcon {
  font-size: 16px;
}

.list-view-toolbar .routItem:last-child .routIcon {
  display: none;
}
</style>